module.exports = __webpack_public_path__ + "static/media/survey-details.dbbb2724.png";